import PropTypes from 'prop-types';
import { ErrorMessage } from '@podiumhq/podium-ui/legacy-build/components/FormInput/FormInputStyledComponents';

import useCreditCardDetailsInputError from './hooks/useCreditCardDetailsInputError';
import CreditCardDetailsToolTip from './CreditCardDetailsToolTip';
import {
  CreditCardDetailsInputInnerWrapper,
  CreditCardDetailsInputLabel,
  CreditCardDetailsInputWrapper,
} from './styles';

const CreditCardDetailsInput = ({
  id,
  InputElement,
  InputIcon,
  label,
  shouldUpdateInvalid = true,
  toolTipOptions,
  zipCodeText,
  ...inputProps
}) => {
  const { onInputChange, inputErrorMessage } = useCreditCardDetailsInputError(
    id,
    shouldUpdateInvalid,
    zipCodeText
  );

  return InputElement ? (
    <CreditCardDetailsInputWrapper
      id={id}
      inputErrorMessage={inputErrorMessage || inputProps?.errorMessage}
    >
      {label && (
        <CreditCardDetailsInputLabel htmlFor={id}>
          {label}
          {toolTipOptions && <CreditCardDetailsToolTip {...toolTipOptions} />}
        </CreditCardDetailsInputLabel>
      )}
      <CreditCardDetailsInputInnerWrapper>
        <InputElement
          id={id}
          onChange={onInputChange}
          {...inputProps}
          className={'.fs-mask'}
        />
        {InputIcon && <InputIcon />}
      </CreditCardDetailsInputInnerWrapper>
      {inputErrorMessage && <ErrorMessage>{inputErrorMessage}</ErrorMessage>}
    </CreditCardDetailsInputWrapper>
  ) : null;
};

CreditCardDetailsInput.propTypes = {
  id: PropTypes.string,
  InputElement: PropTypes.elementType,
  InputIcon: PropTypes.elementType,
  label: PropTypes.string,
  shouldUpdateInvalid: PropTypes.bool,
  toolTipOptions: PropTypes.object,
  zipCodeText: PropTypes.string,
};

export default CreditCardDetailsInput;
